import React from 'react';
import CircularProgress from 'react-md/lib/Progress/CircularProgress';

import './LoadingSpinnerSmall.css'

export default (props) => (
	<div className="loading-spinner-container-small">
		<div className="loading-spinner-small">
			<CircularProgress
				id="loading-spinner-small"
				key="progress"
				scale={2}
			/>
			<p>{props.message}</p>
		</div>
	</div>
);


// WEBPACK FOOTER //
// ./src/components/common/LoadingSpinnerSmall.jsx